import type { BuilderElement } from '@/utils/builder/types';
import { generateId } from '@/utils/builder/id-utils';

const createDefaultSlideParagraph = (): BuilderElement => {
  return {
    id: generateId(),
    type: 'paragraph',
    content: 'This is a paragraph of text. Click to edit this text.',
    styles: {
      fontSize: '16px',
      color: 'primary',
      padding: '10px',
      margin: '0',
    },
    _isNew: true,
    _needsSync: true,
  };
};

const createDefaultSlide = (): BuilderElement => {
  return {
    id: generateId(),
    type: 'container',
    styles: {
      width: '100%',
      height: '100%',
    },
    children: [createDefaultSlideParagraph()],
    _isNew: true,
    _needsSync: true,
  };
};

export const createDefaultCarouselElement = (): BuilderElement => {
  const id = generateId();

  return {
    id,
    type: 'carousel',
    styles: {
      width: '100%',
      height: '400px',
      padding: '20px',
      margin: '10px 0',
    },
    slidesPerView: {
      desktop: 2,
      tablet: 1,
      mobile: 1,
    },
    spaceBetween: {
      desktop: 30,
      tablet: 16,
      mobile: 8,
    },
    autoplayDelay: {
      desktop: 2500,
      mobile: 2000,
    },
    autoPlay: {
      desktop: true,
    },
    loop: {
      desktop: true,
    },
    pagination: {
      desktop: true,
    },
    navigation: {
      desktop: true,
    },
    children: [
      createDefaultSlide(),
      createDefaultSlide(),
      createDefaultSlide(),
    ],
    _isNew: true,
    _needsSync: true,
  };
};


